import { computed } from '@angular/core';
import { patchState, signalStoreFeature, type, withComputed, withMethods } from '@ngrx/signals';
import { ConstructionProjectLoadModel } from '@construction/models/construction-project.model';
import {
  ProcoreIntegration,
  ProcoreProjectPeople,
} from '@construction/modules/project-edit/modules/construction-integrations/construction-integration.types';

/** Reads `project` from upstream state. Owns `activeProcoreUsers` computed signal and `setProcoreIntegration` setter. */
export function withProcore() {
  return signalStoreFeature(
    { state: type<{ project: ConstructionProjectLoadModel }>() },
    withComputed((store) => ({
      activeProcoreUsers: computed((): ProcoreProjectPeople[] => {
        const project = store.project();

        if (!project.procore_integration) return [];

        return project.procore_integration.procore_integration.project_people.filter(
          (member) => member.user_id && member.contact.is_active,
        );
      }),
    })),
    withMethods((store) => ({
      setProcoreIntegration(integration: ProcoreIntegration): void {
        patchState(store, {
          project: { ...store.project(), procore_integration: { procore_integration: integration } },
        });
      },
    })),
  );
}
